export default "__VITE_ASSET__C7bl18NzQfGKZXQsHWD1pg__"